// @unocss-include
'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { shortenTimeUnits } from '@a-type/utils';
import { differenceInMinutes } from 'date-fns/differenceInMinutes';
import { formatDistanceToNowStrict } from 'date-fns/formatDistanceToNowStrict';
import { useEffect, useMemo, useState } from 'react';
function formatDistanceToNow(date, relativeText = true) {
    const now = Date.now();
    if (Math.abs(date.getTime() - now) < 1000) {
        return 'just now';
    }
    return (formatDistanceToNowStrict(date) +
        (relativeText ? (date.getTime() < now ? ' ago' : ' from now') : ''));
}
export function RelativeTime({ value, abbreviate, countdownSeconds, disableRelativeText, }) {
    const asDate = useMemo(() => new Date(value), [value]);
    const [time, setTime] = useState(() => abbreviate
        ? shortenTimeUnits(formatDistanceToNow(asDate, !disableRelativeText))
        : formatDistanceToNow(asDate, !disableRelativeText));
    // increase update rate if the date is less than 1 minute away and in the future
    // (past is ok to just leave ~1 minute)
    const updateRate = countdownSeconds &&
        asDate.getTime() > Date.now() &&
        Math.abs(differenceInMinutes(asDate, new Date())) < 1
        ? 1000
        : 60 * 1000;
    useEffect(() => {
        const update = () => {
            setTime(abbreviate
                ? shortenTimeUnits(formatDistanceToNow(asDate, !disableRelativeText))
                : formatDistanceToNow(asDate, !disableRelativeText));
        };
        const interval = setInterval(update, updateRate);
        update();
        return () => clearInterval(interval);
    }, [asDate, abbreviate, updateRate, disableRelativeText]);
    return _jsx(_Fragment, { children: time });
}
//# sourceMappingURL=RelativeTime.js.map